<div class="app-message-dialog">
  <mat-dialog-content class="text-center">
    @if(data.type === 'id'){
      <div style="text-align: left; margin-bottom: 20px">
        <b
          >If you have forgotten your ID you can find this in 2
          locations:</b
        >
        <br /><br />
        <b>Web:</b> Please log into your Happy HR account and you will find your
        ID under your name on the dashboard. <br /><br />
        <b>App:</b> Go to settings. You will see it under your name in settings.
      </div>
    } @else if (data.type === 'pin') {
      <div style="text-align: left; margin-bottom: 20px">
        <b
          >If you have forgotten your PIN you can find this in 2
          locations:</b
        >
        <br /><br />
        <b>Web:</b> Please log into your Happy HR account and generate your kiosk PIN under Profile > Kiosk Credentials. <br /><br />
        <b>App:</b> Go to settings and generate your kiosk PIN under kiosk credentials.
      </div>
    }
  </mat-dialog-content>
  <mat-divider class="yellow-divider"></mat-divider>
  <mat-dialog-actions>
    <button mat-flat-button mat-dialog-close class="btn-blue">OKAY</button>
  </mat-dialog-actions>
</div>
